
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/temporario",
      function () {
        return require("private-next-pages/temporario.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/temporario"])
      });
    }
  